export const chartType = 'AreaChart';

export const chartData = [
  ['Year', 'Sales'],
  ['2023', 1000],
  ['2024', 1170],
  ['2025', 660],
  ['2026', 1030],
];

export const chartOptions = {
  colors: ['#233975'],
  areaOpacity: 0.75,
  // vAxis: { ticks: { count: 3 } },
  // hAxis: {
  //   viewWindow: {
  //     max: 3
  //   }
  // },

  title: '',
  legend: 'none',
  hAxis: {
    ticks: { count: 100 },
    titleTextStyle: { color: '#333' },
    format: 'd/M/yy',
    gridlines: {count: 100, color: 'none'},


  },
  vAxis: {
    titleTextStyle: { color: '#333' },
    minValue: 0,
    gridlines: {color: '#ccc'}

  },

  chartArea: {
    width: '85%', height: '70%', backgroundColor: {
    }
  },
  width: '100%',
  height: 200,
};
